import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import AppContext from "../../contexts/AppContext";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CompleteSteps from "./CompleteSteps";
export class CompleteStepDetails extends Component {

    render() {
        const stripePromise = loadStripe(this.context.state.stripeKey);

        return (
            <Fragment>
                <Elements stripe={stripePromise}>
                    <CompleteSteps />
                </Elements>
            </Fragment>
        )
    }
}

CompleteStepDetails.contextType = AppContext;
export default withRouter(CompleteStepDetails);


// WEBPACK FOOTER //
// ./src/components/general/CompleteStepDetails.js